import { HaptikBody, HaptikInitconfig } from 'core/models/haptik';
import { HaptikStore } from 'core/stores/haptik.store';
import { _noop } from 'utils/function.utils';

export class HaptikService {
  static initialise(config: HaptikInitconfig) {
    window.haptikInitSettings = config;
  }

  static loadHaptikScript() {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://toolassets.haptikapi.com/platform/javascript-xdk/production/loader.js';
    const x = document.getElementsByTagName('head')[0];
    x.appendChild(script);
  }

  static replaceSDK(config: HaptikInitconfig) {
    if (window.HaptikSDK) {
      window.HaptikSDK.destroy();
      window.haptikInitSettings = config;
      window.HaptikSDK.init(config);
    }

    const haptikStore = new HaptikStore();
    haptikStore.changeIsOpened(false);
  }

  static waitForSDK() {
    return new Promise((resolve, reject) => {
      document.addEventListener(
        'haptik_sdk',
        () => {
          resolve('');
        },
        { once: true }
      );
    });
  }

  static showApp() {
    window.HaptikSDK ? window.HaptikSDK.show() : console.warn('Haptik bot uninitialized');
  }

  static hideApp() {
    window.HaptikSDK ? window.HaptikSDK.hide() : console.warn('Haptik bot uninitialized');
  }

  static launchMessage(message: string, hideMessage = true, hideChatWindow = true, skipMessage = false) {
    window.HaptikSDK.launchMessage(message, _noop, hideMessage, hideChatWindow, skipMessage);
  }

  static signIn(connectUser: HaptikBody) {
    const custom_data = {
      country_code: connectUser.countryCode,
      connect_id: connectUser.connectId,
      customer_no: connectUser.customerNumber,
      authenticated: connectUser.authenticated,
      agreement_id: connectUser.agreementId,
    };

    window.HaptikSDK.signup(
      {
        auth_id: connectUser.customerNumber,
        auth_code: connectUser.idToken,
        email: connectUser.email,
        mobile_no: connectUser.mobileNumber,
        username: '',
        custom_data: custom_data,
      },
      function (success: boolean, error: string) {
        if (!success) {
          console.error('ERROR Signing Up with Haptick:', error);
        }
      }
    );
  }
}

export default HaptikService;